// ===== 环境切换：注释/取消注释下面两行即可 =====
// const API_BASE_URL = 'http://localhost:8080'   // 开发环境
const API_BASE_URL = 'https://haikuntec.cn'       // 生产环境

module.exports = { API_BASE_URL }
